export default __webpack_public_path__ + "static/media/travallo_front.bddb1a43.png";